// ============================================
// MAIN-PRODUCT-SCRIPTS.JS
// Tous les scripts inline du template produit
// ============================================

// === 1. Image Placeholder Loader ===
document.addEventListener('DOMContentLoaded', function () {
  // Sélectionne tous les produits sur la page
  document.querySelectorAll('[id^="product-"]').forEach(function (productEl) {
    const imgs = productEl.querySelectorAll('.product-gallery-item .p-img');
    imgs.forEach(function (img) {
      const done = function () {
        const wrap = img.closest('.product-gallery-item');
        if (wrap) wrap.classList.add('img-loaded');
      };
      if (img.complete) {
        done();
      } else {
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      }
    });
  });
});

// === 2. Size Chart Popup Opener ===
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-open-size-chart]');
  if (!btn) return;
  e.preventDefault();
  var trigger = document.querySelector('.js-toggle-size-chart-modal');
  if (trigger) trigger.click();
});

// === 3. Stock Limiter pour Quantité ===
document.addEventListener('DOMContentLoaded', function () {
  // Cherche le sélecteur de quantité
  var qtyInput = document.querySelector('.qty-selector');
  var btnPlus = document.querySelector('.qty-plus');
  var btnMinus = document.querySelector('.qty-minus');
  
  if (!qtyInput || !btnPlus) return;

  // Récupère le stock depuis l'attribut data
  var stockAttr = qtyInput.getAttribute('data-stock');
  var stock = stockAttr ? parseInt(stockAttr, 10) : 99;

  qtyInput.setAttribute('max', stock);

  btnPlus.addEventListener('click', function () {
    var current = parseInt(qtyInput.value, 10) || 1;
    if (current >= stock) {
      qtyInput.value = stock;
      this.setAttribute('disabled', 'disabled');
    }
  });

  btnMinus.addEventListener('click', function () {
    btnPlus.removeAttribute('disabled');
  });

  qtyInput.addEventListener('input', function () {
    var val = parseInt(this.value, 10) || 1;
    if (val > stock) {
      this.value = stock;
      btnPlus.setAttribute('disabled', 'disabled');
    } else {
      btnPlus.removeAttribute('disabled');
    }
  });
});

// === 5. Carte 3D Tilt Effect (Limited Edition Card) ===
(function () {
  const wrap = document.querySelector('.mb-limited-wrap');
  const card = wrap?.querySelector('.mb-card');
  const shadow = wrap?.querySelector('.mb-card-shadow');
  const shine = wrap?.querySelector('.mb-card-shine');

  if (!wrap || !card) return;
  
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function tilt(e) {
    const r = card.getBoundingClientRect();
    const cx = r.left + r.width / 2;
    const cy = r.top + r.height / 2;
    const dx = (e.clientX - cx) / (r.width / 2);
    const dy = (e.clientY - cy) / (r.height / 2);
    
    // Limites douces
    const rx = Math.max(-1, Math.min(1, -dy)) * 6;  // rotateX
    const ry = Math.max(-1, Math.min(1, dx)) * 8;   // rotateY
    const tz = 10;                                   // Profondeur subtile
    
    if (!reduce) {
      card.style.transform = `rotateX(${rx}deg) rotateY(${ry}deg) translateZ(${tz}px)`;
      shadow.style.transform = `translate(${(-dx) * 6}px, ${(dy) * 8}px) scale(.98)`;
      
      // Shine : angle & déplacement
      const angle = Math.atan2(dy, dx) * 180 / Math.PI + 90;
      shine.style.backgroundImage =
        `linear-gradient(${angle}deg, rgba(255,255,255,0) 30%, rgba(255,255,255,.10) 50%, rgba(255,255,255,0) 70%),` +
        `radial-gradient(60% 120% at 10% 0%, rgba(207,216,255,.10), transparent 60%)`;
    }
  }

  function reset() {
    card.style.transform = '';
    shadow.style.transform = 'translateY(8px) scale(.98)';
  }

  wrap.addEventListener('mousemove', tilt);
  wrap.addEventListener('mouseleave', reset);

  // Mise à jour live si la quantité change (via AJAX)
  document.addEventListener('mb:stock:update', function (e) {
    const n = e.detail?.quantity;
    if (typeof n === 'number') {
      const el = wrap.querySelector('.mb-count');
      if (el) el.textContent = n;
    }
  });
})();

// === 6. SVG Chrome Bevel Filter (3D effect) ===
(function () {
  if (document.getElementById('mbChromeDefsSHARP')) return;

  const NS = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(NS, 'svg');
  svg.id = 'mbChromeDefsSHARP';
  svg.setAttribute('width', '0');
  svg.setAttribute('height', '0');
  svg.style.position = 'absolute';
  
  const defs = document.createElementNS(NS, 'defs');
  const f = document.createElementNS(NS, 'filter');
  f.id = 'mbBevelChromeSHARP';
  f.setAttribute('x', '-28%');
  f.setAttribute('y', '-36%');
  f.setAttribute('width', '156%');
  f.setAttribute('height', '172%');
  f.setAttribute('color-interpolation-filters', 'sRGB');

  // Bump map
  const bump = document.createElementNS(NS, 'feGaussianBlur');
  bump.setAttribute('in', 'SourceAlpha');
  bump.setAttribute('stdDeviation', '0.6');
  bump.setAttribute('result', 'bump');

  // Lobe doux
  const specSoft = document.createElementNS(NS, 'feSpecularLighting');
  specSoft.setAttribute('in', 'bump');
  specSoft.setAttribute('surfaceScale', '2.4');
  specSoft.setAttribute('specularConstant', '1.05');
  specSoft.setAttribute('specularExponent', '16');
  specSoft.setAttribute('kernelUnitLength', '0.55 0.55');
  specSoft.setAttribute('lighting-color', '#ffffff');
  specSoft.setAttribute('result', 'soft');
  
  const Lsoft = document.createElementNS(NS, 'fePointLight');
  Lsoft.id = 'mbSharpLightSoft';
  Lsoft.setAttribute('x', '0');
  Lsoft.setAttribute('y', '-210');
  Lsoft.setAttribute('z', '320');
  specSoft.appendChild(Lsoft);

  // Lobe dur
  const specHard = document.createElementNS(NS, 'feSpecularLighting');
  specHard.setAttribute('in', 'bump');
  specHard.setAttribute('surfaceScale', '5.2');
  specHard.setAttribute('specularConstant', '1.8');
  specHard.setAttribute('specularExponent', '420');
  specHard.setAttribute('kernelUnitLength', '0.45 0.45');
  specHard.setAttribute('lighting-color', '#ffffff');
  specHard.setAttribute('result', 'hard');
  
  const Lhard = document.createElementNS(NS, 'fePointLight');
  Lhard.id = 'mbSharpLightHard';
  Lhard.setAttribute('x', '0');
  Lhard.setAttribute('y', '-185');
  Lhard.setAttribute('z', '380');
  specHard.appendChild(Lhard);

  // Coupe à l'alpha
  const cutSoft = document.createElementNS(NS, 'feComposite');
  cutSoft.setAttribute('in', 'soft');
  cutSoft.setAttribute('in2', 'SourceAlpha');
  cutSoft.setAttribute('operator', 'in');
  cutSoft.setAttribute('result', 'softCut');

  const hardBlur = document.createElementNS(NS, 'feGaussianBlur');
  hardBlur.setAttribute('in', 'hard');
  hardBlur.setAttribute('stdDeviation', '0.10');
  hardBlur.setAttribute('result', 'hardB');

  const cutHard = document.createElementNS(NS, 'feComposite');
  cutHard.setAttribute('in', 'hardB');
  cutHard.setAttribute('in2', 'SourceAlpha');
  cutHard.setAttribute('operator', 'in');
  cutHard.setAttribute('result', 'hardCut');

  // Addition
  const add = document.createElementNS(NS, 'feComposite');
  add.setAttribute('in', 'softCut');
  add.setAttribute('in2', 'hardCut');
  add.setAttribute('operator', 'arithmetic');
  add.setAttribute('k2', '1');
  add.setAttribute('k3', '1.5');
  add.setAttribute('result', 'sum');

  const gamma = document.createElementNS(NS, 'feComponentTransfer');
  gamma.setAttribute('in', 'sum');
  gamma.setAttribute('result', 'sumGamma');
  
  const fa = document.createElementNS(NS, 'feFuncA');
  fa.setAttribute('type', 'gamma');
  fa.setAttribute('amplitude', '1.05');
  fa.setAttribute('exponent', '0.65');
  gamma.appendChild(fa);

  const merge = document.createElementNS(NS, 'feMerge');
  const n1 = document.createElementNS(NS, 'feMergeNode');
  n1.setAttribute('in', 'SourceGraphic');
  const n2 = document.createElementNS(NS, 'feMergeNode');
  n2.setAttribute('in', 'sumGamma');
  merge.appendChild(n1);
  merge.appendChild(n2);

  [bump, specSoft, specHard, cutSoft, hardBlur, cutHard, add, gamma, merge].forEach(x => f.appendChild(x));
  defs.appendChild(f);
  svg.appendChild(defs);
  document.body.appendChild(svg);

  // Animation
  const A = document.getElementById('mbSharpLightSoft');
  const B = document.getElementById('mbSharpLightHard');
  let t0 = performance.now();
  
  function loop(now) {
    const T = 7000;
    const w = 2 * Math.PI * ((now - t0) % T) / T;
    A.setAttribute('x', (180 + 700 * Math.cos(w)).toFixed(2));
    A.setAttribute('y', (-210 + 48 * Math.sin(w * 0.8)).toFixed(2));
    B.setAttribute('x', (180 + 380 * Math.cos(w + Math.PI * 0.35)).toFixed(2));
    B.setAttribute('y', (-185 + 28 * Math.sin(w * 1.05 + Math.PI * 0.2)).toFixed(2));
    requestAnimationFrame(loop);
  }
  
  requestAnimationFrame(loop);
})();

/* Mobile Gallery Dots Sync - VERSION SIMPLE */
if (window.innerWidth <= 768) {
  setTimeout(function() {
    const slider = document.querySelector('.box__product-gallery css-slider');
    const dots = document.querySelectorAll('.product-gallery__thumbnails--dots .thumbnail');
    
    if (!slider || !dots.length) {
      console.log('❌ Slider ou dots introuvables');
      return;
    }
    
    console.log('✅ Trouvé:', slider, dots.length, 'dots');
    
    // Sync scroll → dots
    slider.addEventListener('scroll', function() {
      const index = Math.round(slider.scrollLeft / slider.offsetWidth);
      
      // RETIRE .active de TOUS les dots d'abord
      dots.forEach(dot => dot.classList.remove('active'));
      
      // AJOUTE .active seulement au dot actuel
      if (dots[index]) {
        dots[index].classList.add('active');
      }
    });
    
    // Click dots → scroll
    dots.forEach((dot, i) => {
      dot.onclick = () => slider.scrollTo({ left: slider.offsetWidth * i, behavior: 'smooth' });
    });
  }, 500);
}


// === MB Video toggle (CAPTURE) : marche même si le slider intercepte ===
(function(){
  function toggleFromItem(item, e){
    const v = item.querySelector('video');
    if (!v) return;

    // si c'est un drag, on ne toggle pas
    const moved = Math.abs((e.clientX||0) - (toggleFromItem._sx||0)) + Math.abs((e.clientY||0) - (toggleFromItem._sy||0));
    if (moved > 8) return;

    e.preventDefault();
    e.stopPropagation();

    if (v.paused) v.play().catch(()=>{});
    else v.pause();
  }

  // mémorise le point de départ (pour distinguer drag vs tap)
  document.addEventListener('pointerdown', (e)=>{
    const item = e.target.closest('.product-gallery-item[data-video]');
    if (!item) return;
    toggleFromItem._sx = e.clientX||0;
    toggleFromItem._sy = e.clientY||0;
  }, {capture:true, passive:true});

  // toggle en CAPTURE avant le slider
  document.addEventListener('pointerup', (e)=>{
    const item = e.target.closest('.product-gallery-item[data-video]');
    if (!item) return;
    toggleFromItem(item, e);
  }, {capture:true, passive:false});
})();

(function () {
  function openModal(modal, trigger) {
    // 1) rendre visible (display:flex via CSS)
    modal.classList.add('is-visible');
    modal.setAttribute('aria-hidden', 'false');
    modal._lastTrigger = trigger || null;

    // 2) reset animation puis relance au frame suivant
    modal.classList.remove('is-open');
    modal.offsetHeight; // force reflow

    requestAnimationFrame(() => {
      modal.classList.add('is-open');
      modal.querySelector('.mb-modal__close')?.focus({ preventScroll: true });
    });
  }

  function closeModal(modal) {
    // 1) enlève l'état animé
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');

    // 2) cache après la transition
    window.setTimeout(() => {
      modal.classList.remove('is-visible');
    }, 200);

    modal._lastTrigger?.focus?.({ preventScroll: true });
  }

  document.addEventListener(
    'click',
    (e) => {
      const modal = document.getElementById('mb-sizechart-modal');
      if (!modal) return;

      const trigger = e.target.closest('[data-open-size-chart]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        openModal(modal, trigger);
        return;
      }

      if (modal.classList.contains('is-visible') && e.target.closest('[data-mb-close]')) {
        e.preventDefault();
        closeModal(modal);
      }
    },
    true
  );

  document.addEventListener('keydown', (e) => {
    const modal = document.getElementById('mb-sizechart-modal');
    if (!modal || !modal.classList.contains('is-visible')) return;
    if (e.key === 'Escape') closeModal(modal);
  });
})();
document.getElementById('mb-sizechart-modal')

